import { Component } from '@angular/core';
import { VariableService } from '../services/sharedVariables';
import { Privileges } from '../models/privileges.model';
import { ContractService } from '../services/contract.service';
import { SpecialService } from '../services/special.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'headerweb',
  templateUrl: '../views/page-sections/header.html',
    providers: [ContractService,SpecialService]
})
export class HeaderWebComponent{
  public title:string;
  public logged:boolean;
  public user:string;
  public role:string;
  public privileges:Privileges[];
  public contracts: any[];


  constructor(
    private sharedVariables: VariableService,
    private specialService:SpecialService,
    private contractService: ContractService,
    private _route: ActivatedRoute,
    private _router: Router
  )
  {
    this.title = "Header page";
    this.user="";
    this.role="";
  }

  ngOnInit()
  {
    this.getPrivileges();
    this.getDebts();
  }
  getPrivileges()
  {
    this.sharedVariables.getPrivileges().subscribe(
        response => {
          if(response.code == 200){
            this.user = response.data[0].name;
            this.role = response.data[0].role_name;
            console.log("Privilegios del usuario",this.user);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

  closeSession()
  {
    this.specialService.closeSession().subscribe(
        response => {
          if(response.code == 200){
              console.log("BYE BYE");
              this._router.navigate(['/']);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }
  getDebts()
  {
    this.contractService.getDebts().subscribe(
        response => {
          if(response.code == 200){
            this.contracts = response.data;
            console.log("Deudores",this.contracts);
          }
        },error =>{
          console.log(<any>error);
        }
    );
  }

}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/components/header.component.ts